import axios from 'axios'

class ValidacaoDocumentoApiClient {

    async validarDocumento(codigo) {
        return axios.post('/licitacao/api/public/v1/licitacoes/validardocumento', {codigoAcesso: codigo})
    }

    async baixarDocumentos(idVirtualizado){
        return axios.get(`/licitacao/api/public/v1/licitacoes/documentos/download/${idVirtualizado}`,
            {
                responseType: 'arraybuffer'
            })
    }
}

export default new ValidacaoDocumentoApiClient()
